export interface IRequestEnvelope {
  requestsDto: IRequest[];
  requestCount: number;
}

export interface IRequest {
  id: string;
  requestCaseID: string;
  registrationRequestID: string;
  transactionType: number;
  requestDate: Date;
  tdn: string;
  provider: string;
  serviceType: string;
  documentDate: Date;
  recommendationBy: string | null;
  prevReviewers: string[];
  decisionBy: string | null;
  status: string;
  spanishRequest: boolean;
  age: number;
  noteCount: number;
  currentRequestReviewId: string | null;
  currentRequestReviewerId: string | null;
  currentRequestReviewerName: string | null;
}

//empty form model
export class RequestFormValues {
  id: string = "";
  isSpanish: boolean = false;

  constructor(id?: string, isSpanish?: boolean) {
    if (id) {
      this.id = id;
    }
    if (isSpanish) {
      this.isSpanish = isSpanish;
    }
    Object.assign(this);
  }
}
